import { Fragment } from 'react';
// Background Images
import { ReactComponent as RedTriangle } from 'images/background/hero-section-red-triangle.svg';
import { ReactComponent as RedSquare } from 'images/background/software-solution-graphic-red.svg';
import { ReactComponent as RightBox } from 'images/background/right-box-graphic.svg';
import classes from './BackgroundItems.module.css';

const Index = () => {
  return (
    <Fragment>
      <RedTriangle className={classes['left-red-triangle']} />
      <div className={classes['right-bg-box']}>
        <RightBox className={classes['right-red-box']} />
        <RedSquare className={classes['right-red-square']} />
      </div>
    </Fragment>
  );
};

export default Index;
